<template>
  <div>
    <list-page-header :canAction="canAction('add')" />

    <yv-index
      :path="path"
      :formSearch="formSearch"
      :enableExport="canAction('exportStudent')"
      :columns="columns"
      :disabledHeaderActions="true"
      :bulkActions="tableBulkActions"
      :hideBulkAction="hideBulkAction"
      :sortable="sortable"
      :sort-data="sortData"
      :formatTableData="formatTableData"
      mainField="full_name"
      selectable="multiple"
      ref="studentsTable"
      :permissionConfig="Student"
    >
    </yv-index>
    <common-modal
      width="80%"
      height="auto"
      name="addBehaviorForm"
      :hideFooter="true"
      :hideHeader="true"
    >
      <template #modal-body>
        <BehaviorForm
          mode="add"
          :student="behaviorData"
          modalName="addBehaviorForm"
        ></BehaviorForm>
      </template>
    </common-modal>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { YvIndex } from "@/components/Base";
import { service_paths } from "@/constants/Services";
import Header from "./Header";
import { getId, Message } from "@/helpers/utils";
import { passesIgscTranscriptRule } from "@/helpers/permission";
import { Behavior, Student } from "@/constants/Permissions";
import { DEFAULT_OPTION_ALL } from "@/constants";
import BehaviorForm from "../AccountDetail/Tabs/Behavior/BehaviorForm";
import { generateSex, generateStatus } from "@/helpers/text-helper";

export default {
  name: "ListPage",
  components: { YvIndex, ListPageHeader: Header, BehaviorForm },
  data() {
    return {
      behaviorData: {},
      Behavior,
      Student,
      path: service_paths.students,
      formSearch: [
        {
          label: "common.status",
          name: "status",
          value: "",
          type: "select",
          options: [
            ...DEFAULT_OPTION_ALL,
            {
              id: "Active",
              name: "common.active"
            },
            {
              id: "Inactive",
              name: "common.inactive"
            }
          ]
        },
        {
          label: "common.username",
          name: "username__~",
          value: "",
          type: "input"
        },
        {
          label: "common.full_name",
          name: "full_name__~",
          value: "",
          type: "input"
        },
        {
          label: "common.phone_number",
          name: "phone_number__~",
          value: "",
          type: "input"
        },
        {
          label: "common.email",
          name: "email__~",
          value: "",
          type: "input"
        },
        {
          label: "common.grade",
          name: "grade",
          value: "",
          type: "select",
          is_switch_locale: "false",
          options: []
        },
        {
          label: "student.division",
          name: "division__~",
          value: "",
          type: "input"
        },
        {
          label: "common.student_code",
          name: "student_code__~",
          value: "",
          type: "input"
        },
        {
          label: "common.sex",
          name: "sex",
          value: "",
          type: "select",
          options: [
            ...DEFAULT_OPTION_ALL,
            {
              id: "Female",
              name: "student.female"
            },
            {
              id: "Male",
              name: "student.male"
            },
            {
              id: "Other",
              name: "common.other"
            }
          ]
        },
        {
          label: "common.country",
          name: "country",
          value: "",
          type: "input"
        },
        {
          label: "student.state",
          name: "state",
          value: "",
          type: "input"
        },
        {
          label: "common.source",
          name: "source",
          value: "",
          type: "select",
          is_switch_locale: "false",
          options: []
        },
        {
          label: "common.created_date",
          name: "created_date",
          value: [],
          type: "date-range",
          width: 35
        }
      ],
      sortable: [
        "username",
        "student_code",
        "full_name",
        "status",
        "grade",
        "email"
      ],
      columns: {
        student_code: "common.student_code",
        username: "common.username",
        full_name: "common.full_name",
        grade: "common.grade",
        sex: "common.sex",
        status: "common.status",
        phone_number: "common.phone_number",
        email: "common.email",
        source: "common.source",
        actions: []
      },
      sortData: {
        currentSort: "_id",
        currentSortOrder: "desc"
      },
      tableBulkActions: [],
      generateStatus,
      generateSex
    };
  },
  computed: {
    hideBulkAction() {
      return !(this.canAction("delete") || this.canAction("withdraw"));
    }
  },
  methods: {
    canAction(actionName) {
      return this.$can(Student.actions[actionName], Student.subject);
    },
    setActionByPermission() {
      if (this.canAction("delete")) {
        this.tableBulkActions.push({
          content: this.$t("common.delete"),
          action: () => {
            this.confirmDelete();
          }
        });
      }
      if (this.canAction("viewTranscript") && passesIgscTranscriptRule()) {
        this.columns.actions.push({
          title: this.$t("student.transcript"),
          icon: "description",
          btnClass: { "md-simple": true },
          action: item => {
            this.$router.push(`/students/${getId(item)}/transcript`);
          }
        });
      }
      if (this.canAction("viewCommunicationLog")) {
        this.columns.actions.push({
          title: this.$t("student.communication_log"),
          icon: "phone",
          btnClass: { "md-simple": true },
          action: item => {
            this.setQueryParamsCommunicationLog(item);
          }
        });
      }
      if (this.$can(Behavior.actions.add, Behavior.subject)) {
        this.columns.actions.push({
          title: this.$t("class.behavior"),
          icon: "person_add",
          btnClass: { "md-simple": true },
          action: item => {
            this.behaviorData = item;
            this.$modal.show("addBehaviorForm");
          }
        });
      }
    },
    setQueryParamsCommunicationLog(item) {
      this.$router.push(
        `/students/${getId(item)}/detail?isActiveTabCommunicationLog=true`
      );
    },
    formatTableData(tableData) {
      return tableData.map(studentData => {
        studentData.sex = this.generateSex(studentData.sex);
        studentData.status = this.generateStatus(studentData.status);
        return studentData;
      });
    },
    getGradesList() {
      const inputGrade = this.formSearch.find(item => item.name === "grade");
      this.$axios.get(service_paths.grades, { limit: 20 }).then(({ data }) => {
        if (data) {
          let newArr = [];
          data.data.map(el => {
            newArr.push({
              id: el.name,
              name: el.name
            });
          });
          inputGrade.options = [...DEFAULT_OPTION_ALL, ...newArr];
        }
      });
    },
    getLMSOptions() {
      const inputSource = this.formSearch.find(item => item.name === "source");
      return this.$axios.get(service_paths.lms).then(({ data }) => {
        if (data) {
          let newArr = [];
          data.data.map(el => {
            newArr.push({
              id: el.name,
              name: el.name
            });
          });
          inputSource.options = [...DEFAULT_OPTION_ALL, ...newArr];
        }
      });
    },
    async deleteSelectedStudent() {
      const ids = this.$refs.studentsTable.selectedItems.map(student =>
        getId(student)
      );
      await this.$axios.patch(`${this.path}/delete/ids`, { ids }).then(() => {
        Message.success(this.$t("common.delete_success"));
      });
      // Reload table data
      this.$refs.studentsTable.getTableData();
    },
    confirmDelete() {
      Swal.fire({
        title: this.$t("common.are_you_sure"),
        text: this.$t("common.you_wont_be_able_to_revert_this"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: this.$t("common.yes_delete_it"),
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteSelectedStudent();
        }
      });
    }
  },
  created() {
    this.getGradesList();
    this.getLMSOptions();
    this.setActionByPermission();
  }
};
</script>

<style scoped lang="scss">
.md-button {
  border-radius: 100px !important;
}
</style>
